var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { fixedForwardRef } from "../../../common/LibComponentProps";
var UnwrappedContainer = function (props, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
ref) {
    var as = props.as, children = props.children, fluid = props.fluid, margeExterne = props.margeExterne, className = props.className, style = props.style, size = props.size, otherProps = __rest(props, ["as", "children", "fluid", "margeExterne", "className", "style", "size"]);
    var classContainer = "fr-container";
    /**
     * @deprecated sera supprimé dans une futur Release d'ici fin 2025.
     */
    var isFluid = useMemo(function () {
        if (!fluid) {
            return margeExterne === false;
        }
        return fluid;
    }, [margeExterne, props]);
    var Component = as || "div";
    if (typeof fluid === "string") {
        classContainer += " fr-container-".concat(fluid, "--fluid");
    }
    else if (isFluid && size) {
        classContainer += " fr-container--fluid";
    }
    else if (isFluid) {
        classContainer += "--fluid";
    }
    if (size) {
        classContainer += " fr-container-".concat(size);
    }
    if (className) {
        classContainer += " ".concat(className);
    }
    return (React.createElement(Component, __assign({}, otherProps, { className: classContainer, ref: ref, style: style }), children));
};
var Container = fixedForwardRef(UnwrappedContainer);
export default Container;
